export const CommandesAbonnementDetails = () => {
  return (
    <div>
      <h1>CommandesAbonnementDetails</h1>
    </div>
  );
};
